// utils/otpUtils.js - Refactored with named constants
/**
 * OTP configuration constants
 */
export const OTP_LENGTH = 6;
export const OTP_LAST_INDEX = OTP_LENGTH - 1;

/**
 * OTP utility functions for handling one-time password inputs
 */
export const otpUtils = {
  /**
   * Validate that input contains only digits
   */
  validateInput: (value) => {
    return /^\d*$/.test(value);
  },

  /**
   * Handle OTP input change and auto-focus next input
   */
  handleOtpChange: (index, value, currentOtp, inputRefs) => {
    if (!otpUtils.validateInput(value)) return null;

    const newOtp = [...currentOtp];
    newOtp[index] = value;

    // Auto-focus next input if value entered and not at last input
    if (value !== '' && index < OTP_LAST_INDEX) {
      inputRefs[index + 1]?.focus();
    }

    return newOtp;
  },

  /**
   * Handle backspace key to navigate to previous input
   */
  handleOtpKeyDown: (index, e, currentOtp, inputRefs) => {
    if (e.key === 'Backspace') {
      if (currentOtp[index] === '' && index > 0) {
        const newOtp = [...currentOtp];
        newOtp[index - 1] = '';
        inputRefs[index - 1]?.focus();
        return newOtp;
      }
    }
    return null;
  },

  /**
   * Handle paste event to populate all OTP inputs
   */
  handleOtpPaste: (pastedData, currentOtp, inputRefs) => {
    // Only accept numeric data
    if (!/^\d+$/.test(pastedData)) return null;

    // Extract only the required number of digits
    const digits = pastedData.split('').slice(0, OTP_LENGTH);
    const newOtp = [...currentOtp];

    // Populate OTP inputs with pasted digits
    digits.forEach((digit, index) => {
      if (index < OTP_LENGTH) newOtp[index] = digit;
    });

    // Focus next empty input or last input if all filled
    const nextEmptyIndex = newOtp.findIndex(val => !val);
    if (nextEmptyIndex !== -1) {
      inputRefs[nextEmptyIndex]?.focus();
    } else {
      inputRefs[OTP_LAST_INDEX]?.focus();
    }

    return newOtp;
  }
};